import './ChangeLog.scss';

import React from 'react';

import DrawerTitle from '../../pages/Trafficking/DrawerTitle';
import bem from '../../utils/bem';
import ChangeLogList from './ChangeLogList';
import { Collapse } from './Collapse/Collapse';
import { DateRangeFilter } from './DateRangeFilter/DateRangeFilter';
import { useChangeLog } from './hooks';
import type { ChangeLogProps } from './types';

const [block] = bem('change-log');

const ChangeLog = ({ id, entityType }: ChangeLogProps): JSX.Element | null => {
  const {
    toggles,
    toggleAt,
    toggleAll,
    loading,
    loadingFilter,
    dateRange,
    onClearFilter,
    onDateRangeChange,
    onFilterSubmit,
    filteredLogsToShow,
    onNext,
    hasMore,
  } = useChangeLog({
    id,
    entityType,
  });

  const initialLoading = (loading && !filteredLogsToShow?.length) || loadingFilter;

  // wrapping changelog in a trycatch here to prevent MC crashes.
  try {
    return (
      <div className={block()}>
        <DrawerTitle title="Change Log" />
        <DateRangeFilter
          dateRange={dateRange}
          onClearFilter={onClearFilter}
          onDateRangeChange={onDateRangeChange}
          onFilterSubmit={onFilterSubmit}
        />
        <Collapse toggleAll={toggleAll} />
        <ChangeLogList
          toggles={toggles}
          toggleAt={toggleAt}
          entityType={entityType}
          loading={loading}
          initialLoading={initialLoading}
          filteredLogsToShow={filteredLogsToShow}
          hasMore={hasMore}
          onNext={onNext}
        />
      </div>
    );
  } catch (error) {
    return <div>Changelog has crashed.</div>;
  }
};

export default ChangeLog;
